// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1Rdty","actions__copy":"styles_actions__copy__1AniH"};